import React from "react";

const FinanceIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7594_32145"
        style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="17"
      >
        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7594_32145)">
        <path
          className="prompt-icon"
          d="M10.668 7.75642C10.8312 7.75642 10.9703 7.69897 11.0853 7.58408C11.2002 7.46908 11.2576 7.32997 11.2576 7.16675C11.2576 7.00353 11.2002 6.86442 11.0853 6.74942C10.9703 6.63453 10.8312 6.57708 10.668 6.57708C10.5047 6.57708 10.3656 6.63453 10.2506 6.74942C10.1357 6.86442 10.0783 7.00353 10.0783 7.16675C10.0783 7.32997 10.1357 7.46908 10.2506 7.58408C10.3656 7.69897 10.5047 7.75642 10.668 7.75642ZM5.33464 6.33342H8.66797V5.33341H5.33464V6.33342ZM3.2513 14.1667C2.89919 12.9513 2.5473 11.7419 2.19564 10.5386C1.84386 9.33514 1.66797 8.10008 1.66797 6.83342C1.66797 5.90519 1.99147 5.11758 2.63847 4.47058C3.28547 3.82358 4.07308 3.50008 5.0013 3.50008H8.5013C8.80641 3.09919 9.17247 2.77675 9.59947 2.53275C10.0264 2.28875 10.4936 2.16675 11.0013 2.16675C11.1851 2.16675 11.3421 2.23191 11.4725 2.36225C11.6028 2.49258 11.668 2.64964 11.668 2.83341C11.668 2.87875 11.6617 2.92403 11.6493 2.96925C11.637 3.01458 11.624 3.05647 11.6103 3.09491C11.5487 3.25558 11.4964 3.42014 11.4531 3.58858C11.41 3.75691 11.3731 3.92697 11.3423 4.09875L13.077 5.83341H14.3346V9.90641L12.5153 10.5039L11.418 14.1667H8.33464V12.8334H6.33464V14.1667H3.2513ZM4.0013 13.1667H5.33464V11.8334H9.33464V13.1667H10.668L11.7013 9.73342L13.3346 9.18342V6.83342H12.668L10.3346 4.50008C10.3346 4.27786 10.3485 4.06397 10.3763 3.85841C10.4041 3.65286 10.45 3.44664 10.5141 3.23975C10.1919 3.32864 9.91069 3.48358 9.67047 3.70458C9.43036 3.92547 9.24619 4.19064 9.11797 4.50008H5.0013C4.35686 4.50008 3.80686 4.72786 3.3513 5.18341C2.89575 5.63897 2.66797 6.18897 2.66797 6.83342C2.66797 7.9223 2.81797 8.98619 3.11797 10.0251C3.41797 11.064 3.71241 12.1112 4.0013 13.1667Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default FinanceIcon;
